import permissions from '../../data/permissions';

export default [
    {
        name: "SupplierCreate",
        path: "supplier",
        component: () => import('./../../views/purchase/SupplierCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier.create }
    },
    {
        name: "SupplierDisplay",
        path: "supplier/:id",
        component: () => import('./../../views/purchase/SupplierDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier.read }
    },
    {
        name: "SupplierEdit",
        path: "supplier/:id/edit",
        component: () => import('./../../views/purchase/SupplierEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier.update }
    },
    {
        name: "SupplierList",
        path: "suppliers",
        component: () => import('./../../views/purchase/SupplierListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier.index }
    }
]